import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Dropdown } from "antd";
import { ReactComponent as More } from "../../../../../../../assets/icons/more.svg";
import { ReactComponent as Download } from "../../../../../../../assets/icons/download.svg";
import { ReactComponent as Delete } from "../../../../../../../assets/icons/delete.svg";
import { ReactComponent as Cut } from "../../../../../../../assets/icons/cut.svg";
import { ReactComponent as Merge } from "../../../../../../../assets/icons/merge.svg";
import { ReactComponent as Speed } from "../../../../../../../assets/icons/speed.svg";
import { ReactComponent as CropAndRotate } from "../../../../../../../assets/icons/crop-rotate.svg";
import { ReactComponent as Resize } from "../../../../../../../assets/icons/resize.svg";
import { ReactComponent as RemoveWatermark } from "../../../../../../../assets/icons/remove-watermark.svg";
import { ReactComponent as Mute } from "../../../../../../../assets/icons/mute.svg";
import { ReactComponent as AddMusic } from "../../../../../../../assets/icons/add-music.svg";
import { ReactComponent as Subtitle } from "../../../../../../../assets/icons/subtitle.svg";
import { ReactComponent as AddWatermark } from "../../../../../../../assets/icons/add-watermark.svg";
import { ReactComponent as Reverse } from "../../../../../../../assets/icons/reverse.svg";
import { ReactComponent as Loop } from "../../../../../../../assets/icons/loop.svg";
import { ReactComponent as SelectItem } from "../../../../../../../assets/icons/selectItem.svg";
import { ReactComponent as PreAudio } from "../../../../../../../assets/icons/preAudio.svg";
import { ReactComponent as ToGif } from "../../../../../../../assets/icons/ToGif.svg";
import { ReactComponent as Convert } from "../../../../../../../assets/icons/Convert.svg";
import { ReactComponent as Convert2 } from "../../../../../../../assets/icons/Convert2.svg";
import { ReactComponent as Convert3 } from "../../../../../../../assets/icons/Convert3.svg";
import { ReactComponent as Extract } from "../../../../../../../assets/icons/Extract.svg";
import { ReactComponent as FaceAnimator } from "../../../../../../../assets/icons/FaceAnimator.svg";
import { ReactComponent as DynamicPhoto } from "../../../../../../../assets/icons/DynamicPhoto.svg";
import { ReactComponent as Compress } from "../../../../../../../assets/icons/Compress.svg";
import { ReactComponent as ChangeVolume } from "../../../../../../../assets/icons/ChangeVolume.svg";
import { ReactComponent as BackgroundRemove } from "../../../../../../../assets/icons/BackgroundRemove.svg";

import Utils from "../../../../../../../../../utils";
import moment from "moment";
const FileItemRender = ({ file, handleSelectClick, handleDelete, handleDownloadClick, selectGuidList, isEditing }) => {
  let ItemRef = React.createRef();
  const { t } = useTranslation(["personalCenterHistory"]);
  const operation = () => {
    return (
      <div className="file-operation">
        <Download
          onClick={e => {
            e.stopPropagation();
            handleDownloadClick(file);
          }}
        />
        <Delete
          onClick={e => {
            e.stopPropagation();
            handleDelete(file);
          }}
        />
      </div>
    );
  };
  const renderSwitch = args => {
    let param = args.split("/")[1];
    if (param == "Convert" && args.split("/")[0] == "Audio") {
      param = "Convert2";
    } else if (param == "Convert" && args.split("/")[0] == "Image") {
      param = "Convert3";
    }
    switch (param) {
      case "Cut":
        return <Cut />;
      case "Merge":
        return <Merge />;
      case "ChangeSpeed":
        return <Speed />;
      case "CropAndRotate":
        return <CropAndRotate />;
      case "Resize":
        return <Resize />;
      case "RemoveWatermark":
        return <RemoveWatermark />;
      case "Mute":
        return <Mute />;
      case "MuteVideo":
        return <Mute />;
      case "AddMusic":
        return <AddMusic />;
      case "Mix":
        return <AddMusic />;
      case "AddSubtitle":
        return <Subtitle />;
      case "AddWatermark":
        return <AddWatermark />;
      case "Reverse":
        return <Reverse />;
      case "Loop":
        return <Loop />;
      case "ToGif":
        return <ToGif />;
      case "Convert":
        return <Convert />;
      case "Convert2":
        return <Convert2 />;
      case "Convert3":
        return <Convert3 />;
      case "Extract":
        return <Extract />;
      case "FaceAnimator":
        return <FaceAnimator />;
      case "DynamicPhoto":
        return <DynamicPhoto />;
      case "Compress":
        return <Compress />;
      case "ChangeVolume":
        return <ChangeVolume />;
      case "BackgroundRemove":
        return <BackgroundRemove />;

      default:
        return "";
    }
  };
  const imgUrl = () => {
    let res = "";
    if (file.media_type == "Video") {
      res = <img src={file.thumbnail_urls[0]} alt="thumbnail" />;
    } else if (file.media_type == "Image") {
      res = <img src={file.url} alt="thumbnail" />;
    } else {
      res = <PreAudio />;
    }
    return res;
  };
  // const timeMsg = () => {
  //   let res = ""
  //   if (file.media_type == "Video") {
  //     res = <img src={file.thumbnail_urls[0]} alt="thumbnail" />
  //   } else if (file.media_type == "Image") {
  //     res = <img src={file.url} alt="thumbnail" />
  //   } else {
  //     res = <PreAudio />
  //   }
  //   return res
  // };
  let duration = (file.video_media_info && file.video_media_info.duration) || (file.audio_media_info && file.audio_media_info.duration) || "";
  duration = duration
    ? moment("00:00:00", "mm:ss:SS")
        .add(parseFloat(duration), "seconds")
        .format("mm:ss:SS")
        .replace(/:([^:]*)$/, ".$1")
    : "";
  return (
    <Col span={8}>
      <div className="fileItem" ref={ItemRef} onClick={isEditing ? () => handleSelectClick(file) : null}>
        <div className="inner">
          {imgUrl()}
          {/* hover效果 */}
          <div className="fileItem-modal">
            <Dropdown overlay={operation()} placement="bottomRight" getPopupContainer={() => ItemRef.current} onClick={e => e.stopPropagation()}>
              <More className="more-btn" />
            </Dropdown>
            <div className="fileItem-info">
              <span>{duration}</span>
              {/* {file.file_size} */}
              <span>{Utils.getSize(file.file_size)}</span>
            </div>
          </div>
          {/* 选中效果 */}
          <div className="fileItem-select-modal" style={{ display: selectGuidList.some(item => item == file.job_id) && isEditing ? "flex" : "none" }}>
            <SelectItem />
          </div>
        </div>
      </div>
      {/* 文件功能信息 */}
      <div className="fileItem-time">
        <span>
          {/* {file.created_at} Original file*/}
          {file.media_job_type.split("/")[1] == "Upload" || file.media_job_type.split("/")[1] == "Uploading"
            ? t("originalFile")
            : t(Utils.getUpdateTime(file.created_at).i18Key, { num: Utils.getUpdateTime(file.created_at).num })}
        </span>
        {renderSwitch(file.media_job_type)}
      </div>
    </Col>
  );
};

export default FileItemRender;
